import { useContext } from 'react'

import { context } from './context'
import type { AppConfiguration } from './types'

/**
 * Hook for retrieving the current app configuration context. Will throw an error if the context has not been defined.
 */
export const useConfigurationContext = <T extends AppConfiguration>() => {
  const appConfigurationContext = useContext(context)

  if (!appConfigurationContext) {
    throw new Error('The app configuration context has not been initialized')
  }

  return appConfigurationContext as T
}
